import {
  deleteApiTagsId,
  getApiTagsId,
  postApiTags,
  putApiTagsId,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const tagByIdQuery = createQuery({
  handler: getApiTagsId,
})

export const tagCreate = createMutation({
  handler: postApiTags,
})

export const tagUpdate = createMutation({
  handler: putApiTagsId,
})

export const tagDelete = createMutation({
  handler: deleteApiTagsId,
})
